module.exports = __webpack_public_path__ + "img/bg-darkblue.33de0214.png";